export interface DOBErrorStates {
  day: boolean;
  month: boolean;
  year: boolean;
}

const NO_ERROR_STATE: DOBErrorStates = { day: false, month: false, year: false };
const ALL_ERROR_STATE: DOBErrorStates = { day: true, month: true, year: true };

export function parseDOBErrorStates(errorMessage?: string): DOBErrorStates {
  if (!errorMessage) {
    return NO_ERROR_STATE;
  }

  const lowerCaseMessage = errorMessage.toLowerCase();

  const dayError = lowerCaseMessage.includes("day");
  const monthError = lowerCaseMessage.includes("month");
  const yearError = lowerCaseMessage.includes("year");

  if (dayError || monthError || yearError) {
    return { day: dayError, month: monthError, year: yearError };
  }

  return ALL_ERROR_STATE;
}
